module.exports = __webpack_public_path__ + "static/media/caret-b.57269fdd.svg";